// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"MainLayout_mainLayout__TmIWa"};